(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/collections/transfer-draws.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/collections/transfer-draws.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.collections.TransferDraws = Backbone.Collection.extend({
    log: new svs.core.log.Logger('svs.tipset.models.TransferDraws'),
    productToLookFor: 0,

    initialize: function() {
      var transferProductApiName = '';

      switch (
        svs.tipset.models.gameDefinitions.getAPIName(
          svs.tipset.collections.draws.getCurrentDraw().get('productId')
        )
      ) {
        case 'STRYK':
          transferProductApiName = 'topptipsetfamily';
          this.productToLookFor = 23;
          break;
        case 'ITA':
          transferProductApiName = 'topptipsetfamily';
          this.productToLookFor = 24;
          break;
        case 'T8STRYK':
          transferProductApiName = 'stryktipset';
          this.productToLookFor = 1;
          break;
        case 'T8EXTRA':
          transferProductApiName = 'europatipset';
          this.productToLookFor = 2;
          break;
        default:
      }
      this.url =
        svs.core.jupiter.url() +
        '/draw/' +
        transferProductApiName +
        '/draws?include=draws.productId,draws.drawNumber,draws.regCloseTime,draws.drawStateId';
      this.fetch();
    },

    parse: function(response) {
      this.log.debug('parse ' + response.draws.length, response);
      var self = this;
      response.draws = response.draws.filter(function(draw) {
        return (
          draw.productId == self.productToLookFor &&
          draw.drawStateId == svs.tipset.constants.DRAW_STATE_OPEN
        );
      });

      _.each(response.draws, function(draw) {
        draw.urlAddOn =
          draw.productId.toString() + '_' + draw.drawNumber.toString();
      });
      return response.draws;
    }
  });
})(Backbone, _, svs);

 })(window);